import { render, staticRenderFns } from "./FormBuilding.vue?vue&type=template&id=7e398e9c"
import script from "./FormBuilding.vue?vue&type=script&lang=js"
export * from "./FormBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports